import { locationCountryCode } from "@/lib/countryFlag";

interface PluginLocation {
  country_code?: string | null;
  country?: string | null;
}

/**
 * Drapeau pays en IMAGE SVG (flag-icons) — robuste cross-OS, contrairement aux
 * emojis-drapeaux qui ne s'affichent pas sur Chrome/Edge sous Windows (ils
 * retombent sur les 2 lettres « FR »).
 *
 * Rend `null` si le pays est inconnu / IP privée (« Local »).
 * Nécessite l'import global `flag-icons/css/flag-icons.min.css` (cf. main.tsx).
 */
export function CountryFlag({
  location,
  className = "",
}: {
  location: PluginLocation | null | undefined;
  className?: string;
}) {
  const code = locationCountryCode(location);
  if (!code) return null;
  return (
    <span
      className={`fi fi-${code.toLowerCase()} rounded-[2px] shrink-0 ${className}`.trim()}
      title={code}
      aria-label={code}
      role="img"
    />
  );
}
